import React from 'react';

const HelpPage = () => {
  const faqs = [
    {
      question: "How accurate is the Tabby detection?",
      answer: "Our detection system achieves 90%+ accuracy through comprehensive analysis of multiple page types including homepages, product pages, checkout flows, and payment sections. We provide confidence ratings and visual evidence for each result."
    },
    {
      question: "How long does a website check take?",
      answer: "Most website checks complete in under 3 seconds. For comprehensive multi-page analysis (up to 12 pages), the process may take 10-15 seconds to ensure thorough coverage."
    },
    {
      question: "What types of pages do you analyze?",
      answer: "We analyze multiple page types including homepages, product pages, category pages, checkout flows, payment sections, and cart pages to provide comprehensive Tabby integration detection."
    },
    {
      question: "What if the tool shows 'Tabby Not Found' but I know the site accepts Tabby?",
      answer: "While our system is highly accurate, some integrations might be detected differently. This could happen if Tabby is only available in certain regions, for specific products, or implemented in a unique way. Try checking a specific product page URL if you tested the homepage."
    },
    {
      question: "Can I check websites in different regions?",
      answer: "Yes, our tool works with websites globally. However, some merchants may only offer Tabby in specific regions or countries, which will be reflected in the detection results and metadata."
    },
    {
      question: "What formats can I enter for URLs?",
      answer: "You can enter URLs in various formats: 'shopify.com', 'amazon.ae', 'https://noon.com', etc. Our system automatically adds the protocol if missing and validates the URL format."
    },
    {
      question: "Is there a limit to how many websites I can check?",
      answer: "There are no limits on the number of websites you can check. The tool is designed for both casual users and business professionals conducting extensive competitive research."
    },
    {
      question: "What should I do if I encounter an error?",
      answer: "If you encounter an error, first check that you've entered a valid website URL. If the problem persists, it might be due to the target website being temporarily unavailable or blocking automated requests. Try again later or test a different URL."
    }
  ];

  return (
    <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }}>
      {/* PAGE_HELP: FAQ and troubleshooting guidance */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '48px 24px' 
      }}>
        <h1 style={{
          fontSize: '35px',
          lineHeight: '1.03',
          fontWeight: 600,
          color: '#000000', // Pure black for heading
          letterSpacing: '-0.02em',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          margin: '0 0 32px 0'
        }}>
          Help & Support
        </h1>
        
        <div style={{ marginBottom: '48px' }}>
          <p style={{
            fontSize: '16px',
            color: '#6B7785', // Tabby secondary text color
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            lineHeight: '1.5',
            margin: '0'
          }}>
            Find answers to common questions about the Tabby Website Checker and troubleshooting guidance to help you get the most out of the tool.
          </p>
        </div>

        {/* FAQ Section */}
        <section>
          <h2 style={{
            fontSize: '22px',
            lineHeight: '1.09',
            fontWeight: 600,
            color: '#000000',
            letterSpacing: '-0.01em',
            margin: '0 0 32px 0',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
          }}>
            Frequently Asked Questions
          </h2>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {faqs.map((faq, index) => (
              <div 
                key={index}
                style={{ 
                  padding: '24px 0',
                  borderBottom: index < faqs.length - 1 ? '1px solid #E5E7EB' : 'none'
                }}
              >
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#1A202C',
                  margin: '0 0 12px 0',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
                }}>
                  {faq.question}
                </h3>
                <p style={{ 
                  color: '#6B7785',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  margin: '0',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
                }}>
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Contact Section */}
        <section style={{ marginTop: '48px', padding: '24px', backgroundColor: '#F8F9FA', borderRadius: '8px' }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: 600,
            color: '#1A202C',
            margin: '0 0 12px 0',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
          }}>
            Need More Help?
          </h3>
          <p style={{ 
            color: '#6B7785',
            fontSize: '14px',
            lineHeight: '1.5',
            margin: '0',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
          }}>
            If you can't find the answer you're looking for, or if you encounter any technical issues, please visit the official Tabby support resources or contact the development team for assistance.
          </p>
        </section>
      </div>
    </div>
  );
};

export default HelpPage;
